const LIVE_BACKEND_URL = "https://greatleadersnetworkbackend.onrender.com";

export function getBackendUrl() {
  const fromEnv = String(process.env.REACT_APP_BACKEND_URL || "").trim();
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return "http://localhost:3004";
  }
  return LIVE_BACKEND_URL;
}
